import React, { useEffect, useState } from "react"
import { Image, ScrollView, View } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import {
    apiIdle,
    apiRequest,
    apiRequestWithPrerequest,
} from "@data/redux/actions/api"
import { connect } from "react-redux"
import { StatusBar } from "@common/systemBars/StatusBar"
import logo from "../../assets/logo-blue.png"
import { subscriptionService } from "@data/services/subscriptionService"
import { useApiStatus } from "@common/hooks/useApiStatus"
import base64 from "@common/utils/base64"
import { useNavigation } from "@react-navigation/native"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { PricingTableM } from "./PricingTableM"
import AvatarM from "@common/components/avatar/AvatarM"
import { isSubscribed, isSubscriptionPaused } from "@data/utility/dataUtils"

import MySubscriptionInfos from "../student/account/subscription/MySubscriptionInfos"
import { ToggleButtonM } from "@common/components/button/ToggleButtonM"
import { useController } from "react-hook-form"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import * as amplitude from "@amplitude/analytics-react-native"
import NextLiveSessionBanner from "../student/activity/todo/NextLiveSessionBanner"
import { TouchableOpacity } from "@gorhom/bottom-sheet"
import TitleM from "@common/components/text/TitleM"
import { setBugsnagUser } from "@common/utils/initBugsnag"
import FAQComponent from "@common/components/FAQ/FAQComponent"
import moment from "moment"
import { ReferralActionCard } from "@common/account/ReferralActionCard"
import { ProfileSection } from "../student/account/ProfileSection"
import { IconImageM } from "@common/components/icons/IconsM"
import { ScreenSkeleton } from "../common/screens/ScreenSkeleton"
import OpenInvoicesModal from "../student/subscribe/OpenInvoicesModal"

function PricingComponent(props) {
    const {
        control,
        goToNextStep,
        setFormValues = () => {},
        userEmail,
        pricingTableData,
        startNextMonth,
        pricingTableDataNextMode,
        subscribedProductPriceId,
        forceBigSize = false,
    } = props

    const { field: productNameField } = control
        ? useController({
              control,
              name: "product_name",
          })
        : {}

    const { field: withCommitmentField } = control
        ? useController({
              control,
              name: "with_commitment",
          })
        : {}

    const [withCommitment, setWithCommitment] = useState(
        withCommitmentField?.value ?? 1
    )

    const advantage = !withCommitment
        ? pricingTableData?.[0]?.advantage
        : pricingTableData?.[0]?.prices?.monthly?.commitment_discount_data
              ?.advantage_in_months

    return (
        <>
            <ToggleButtonM
                labels={[
                    <View key="monthly" style={{ alignItems: "center" }}>
                        <TextM
                            fontSize={10}
                            fontWeight={"ExtraBold"}
                            color={theme.colors.gray}
                        >
                            Engagement mensuel
                        </TextM>
                        <TextM fontSize={8}>Paiement mensuel</TextM>
                    </View>,
                    <View key="annual" style={{ alignItems: "center" }}>
                        <TextM
                            fontSize={10}
                            fontWeight={"ExtraBold"}
                            color={theme.colors.success}
                        >
                            Engagement annuel*
                        </TextM>
                        <TextM fontSize={8}>Paiement mensuel</TextM>
                    </View>,
                ]}
                buttonsStyle={{ width: 180 }}
                initialIndex={withCommitment}
                onSelectIndex={setWithCommitment}
                onPressAdditional={() => {
                    withCommitmentField?.onChange(!withCommitment ? 1 : 0)
                    setFormValues({
                        ...control?._formValues,
                        with_commitment: !withCommitment ? 1 : 0,
                    })
                }}
            />
            <TextM
                color={
                    withCommitment ? theme.colors.success : theme.colors.grey
                }
                fontWeight={withCommitment ? "Medium" : "Regular"}
                style={{ textAlign: "center", marginHorizontal: 10 }}
                wrap
            >
                {advantage}
            </TextM>
            {withCommitment ? (
                <TextM
                    fontWeight={"Light"}
                    style={{
                        textAlign: "center",
                        marginHorizontal: 10,
                        marginTop: 10,
                    }}
                    fontSize={12}
                    wrap
                >
                    *Vous hésitez ? Résiliation possible sans condition pendant
                    le 1er mois !
                </TextM>
            ) : null}

            <PricingTableM
                startNextMonth={startNextMonth}
                withCommitment={withCommitment}
                onPress={
                    control
                        ? (productName, withCommitment) => {
                              productNameField.onChange(productName)
                              withCommitmentField.onChange(withCommitment)
                              setFormValues({
                                  ...control._formValues,
                                  product_name: productName,
                                  with_commitment: withCommitment,
                              })
                              goToNextStep()
                          }
                        : null
                }
                userEmail={userEmail}
                pricingTableData={pricingTableData}
                pricingTableDataNextMode={pricingTableDataNextMode}
                subscribedProductPriceId={subscribedProductPriceId}
                forceBigSize={forceBigSize}
            />
        </>
    )
}

export function ChooseSubscriptionOffer(props) {
    const { forceBigSize = false } = props

    return forceBigSize ? (
        <ScrollView
            contentContainerStyle={{
                alignItems: "center",
                alignSelf: "center",
                padding: 20,
            }}
        >
            <PricingComponent {...props} />
        </ScrollView>
    ) : (
        <View
            style={{
                alignItems: "center",
                alignSelf: "center",
            }}
        >
            <PricingComponent {...props} />
        </View>
    )
}

const SubscribeScreen = (props) => {
    const userEmailb64 = props.route?.params?.user ?? ""
    const userEmail = base64.decode(userEmailb64.replace(/-/g, ""))

    // if we are less than 2,5 days before the first of next month, then we start next month
    const startNextMonth =
        props.route?.params?.start_next_month ??
        moment()
            .startOf("month")
            .add(1, "month")
            .startOf("month")
            .diff(moment(), "hours") < 60

    const initialShowDetails = !!props.route?.params?.show_details ?? false
    const status =
        props.route?.params?.status ??
        props.route?.params?.redirect_status ??
        null
    const showOpenInvoicesParam =
        props.route?.params?.show_open_invoices === "1"

    //remove any "-" in the base64 email and replace it by ""
    const navigation = useNavigation()

    const [openInvoicesModalVisible, setOpenInvoicesModalVisible] = useState(
        showOpenInvoicesParam
    )

    const pricingTableData = props.pricingTableData
    const pricingTableDataNextMode = props.pricingTableDataNextMode
    const billingPortalUrl = props.billingPortalUrl
    const user = props.user

    const insets = useSafeAreaInsets()

    useEffect(() => {
        if (!props.currentUser || props.currentUser?.email === userEmail) {
            amplitude.setUserId(userEmail)
            setBugsnagUser({ id: "-", email: userEmail, display_name: "-" })
        }

        // get infos from back
        props.apiRequest(
            subscriptionService.getSubscribePricing,
            {},
            {},
            { email: userEmail }
        )

        if (["success", "succeeded"].includes(status)) {
            DialogM.show({
                text1: "Félicitations ! 🎉",
                text2: "Votre abonnement a bien été activé. Un mail de confirmation vous a été envoyé.",
            })
            navigation.setParams({
                ...props.route.params,
                status: null,
                redirect_status: null,
            })
        }
    }, [])

    useApiStatus(
        subscriptionService.getSubscribePricing, // api service
        null, // success message on toast (string or null)
        false, // error message on toast (true) or keep it in redux state (false)
        () => {}, // success callback
        (error) => console.log(error),
        true
    )

    return (
        <ScreenSkeleton
            isLoading={props.request}
            errorScreenProps={{ error: props.error }}
            withCenterContent
        >
            <View
                style={{
                    width: "100%",
                    marginBottom: 20,
                    marginTop: insets.top + 10,
                    alignItems: "center",
                    alignSelf: "center",
                    justifyContent: "space-between",
                    flexDirection: "row",
                }}
            >
                <Image
                    style={{ width: 100, height: 50 }}
                    resizeMode="contain"
                    source={logo}
                />
                <View
                    style={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                        flexDirection: "row",
                    }}
                >
                    <View style={{ marginRight: 15 }}>
                        <TextM
                            color={theme.colors.primary}
                            fontWeight={"Medium"}
                            wrap
                            style={{ textAlign: "right" }}
                        >{`${user?.firstname} ${user?.lastname}`}</TextM>
                        <TextM
                            color={theme.colors.grey}
                            fontWeight={"Light"}
                            wrap
                            fontSize={10}
                            style={{ textAlign: "right" }}
                        >{`${user?.email}`}</TextM>
                    </View>
                    <AvatarM user={user} size={32} />
                </View>
            </View>

            {!isSubscribed(user) && !isSubscriptionPaused(user) ? (
                <>
                    <TextM
                        fontWeight={"ExtraBold"}
                        color={theme.colors.primary}
                        fontSize={32}
                        style={{
                            textAlign: "center",
                            marginTop: 30,
                            marginBottom: 20,
                        }}
                        wrap
                    >
                        S&apos;abonner
                    </TextM>
                    <TextM
                        fontWeight={"Regular"}
                        fontSize={16}
                        style={{ textAlign: "center", marginBottom: 10 }}
                        wrap
                    >
                        Choisissez votre formule
                    </TextM>
                    <ChooseSubscriptionOffer
                        userEmail={userEmail}
                        startNextMonth={startNextMonth}
                        pricingTableDataNextMode={pricingTableDataNextMode}
                        pricingTableData={pricingTableData}
                    />
                    {props.faq?.length > 0 && (
                        <FAQComponent faqs={props.faq} withTitle />
                    )}
                </>
            ) : (
                <>
                    <TextM
                        fontWeight={"ExtraBold"}
                        color={theme.colors.primary}
                        fontSize={32}
                        style={{
                            textAlign: "center",
                            marginTop: 0,
                            marginBottom: 10,
                        }}
                        wrap
                    >
                        {"Espace parent"}
                    </TextM>
                    {!props.user?.subscription_state?.is_manual_sub && (
                        <ReferralActionCard
                            style={{ marginBottom: 20, width: "100%" }}
                            user={props.user}
                        />
                    )}
                    <NextLiveSessionBanner
                        noButton
                        forceAllLivesButton
                        subscriptionUser={props.user}
                        tutorIds={
                            props.route?.params?.send_message_to_tutors ?? 0
                        }
                    />
                    {props.user?.current_study_programs?.length > 0 && (
                        <ProfileSection
                            title={"Mes programmes de révision"}
                            noBorder
                            style={{ paddingBottom: 20, width: "100%" }}
                        >
                            {props.user?.current_study_programs?.map(
                                (studyProgram) => {
                                    return (
                                        <TouchableOpacity
                                            key={studyProgram?.id}
                                            onPress={() => {
                                                navigation.push(
                                                    "study-program",
                                                    {
                                                        id: studyProgram?.id,
                                                    }
                                                )
                                            }}
                                            style={{
                                                borderWidth: 1,
                                                borderRadius: 15,
                                                borderColor:
                                                    theme.colors.lightMore,
                                                backgroundColor:
                                                    theme.colors.white,
                                                marginBottom: 10,
                                            }}
                                        >
                                            <View
                                                style={{
                                                    alignItems: "flex-start",
                                                    flex: 1,
                                                    paddingVertical: 10,
                                                    paddingHorizontal: 15,
                                                }}
                                            >
                                                {
                                                    <TitleM
                                                        style={{
                                                            fontSize: 16,
                                                            marginBottom: 0,
                                                        }}
                                                    >
                                                        {studyProgram?.title}
                                                    </TitleM>
                                                }
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        marginTop: 5,
                                                    }}
                                                >
                                                    {studyProgram?.school_subjects?.map(
                                                        (
                                                            schoolSubject,
                                                            index
                                                        ) => (
                                                            <IconImageM
                                                                key={index}
                                                                uri={
                                                                    schoolSubject?.icon
                                                                }
                                                                style={{
                                                                    marginRight: 5,
                                                                }}
                                                                width={20}
                                                            />
                                                        )
                                                    )}
                                                    <TextM
                                                        color={
                                                            theme.colors.primary
                                                        }
                                                        size={12}
                                                        fontWeight={"Regular"}
                                                    >
                                                        {
                                                            studyProgram
                                                                ?.school_subject
                                                                ?.name
                                                        }{" "}
                                                        - {studyProgram.class}
                                                    </TextM>
                                                </View>
                                            </View>
                                        </TouchableOpacity>
                                    )
                                }
                            )}
                        </ProfileSection>
                    )}
                    <View
                        style={{
                            alignSelf: "center",
                            width: "100%",
                        }}
                    >
                        <MySubscriptionInfos
                            user={user}
                            currentTableData={user?.current_table_data}
                            plannedTableData={user?.planned_table_data}
                            billingPortalUrl={billingPortalUrl}
                            initialShowDetails={initialShowDetails}
                            onOpenInvoices={() =>
                                setOpenInvoicesModalVisible(true)
                            }
                        />
                    </View>
                </>
            )}

            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />

            <OpenInvoicesModal
                visible={openInvoicesModalVisible}
                setVisible={setOpenInvoicesModalVisible}
                userEmail={userEmail}
            />
        </ScreenSkeleton>
    )
}
const mapStateToProps = (state) => {
    return {
        request: state.api.getSubscribePricing?.request,
        success: state.api.getSubscribePricing?.success,
        error: state.api.getSubscribePricing?.error,
        currentUser: state.data.currentUser?.object,
        user: state.data.formData?.user,
        billingPortalUrl: state.data.formData?.billingPortalUrl,
        pricingTableData: state.data.formData?.pricingTableData,
        pricingTableDataNextMode: state.data.formData?.pricingTableDataNextMode,
        faq: state.data.formData?.faq,
    }
}

const mapDispatchToProps = {
    apiRequestWithPrerequest,
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscribeScreen)
